<template>
    <b-modal
      :id="id"
      size="lg"
      :title="title"
      :ok-title="trans('buy')"
      :ok-disabled="busy"
      @shown="onShown"
      @hidden="onHidden"
      @ok="onBuy"
    >
      <b-overlay :show="!loaded">
        <div v-for="(item, index) in items" class="mb-3" :key="index">
          <h6>{{ item.name }}</h6>
          <b-form-checkbox-group
            :options="item.addons"
            v-model="selected[index]"
            stacked
          />
        </div>
      </b-overlay>
      <p v-if="loaded && items.length == 0">{{ trans('no_addons') }}</p>
    </b-modal>
  </template>
  
  <script>
    export default {
      props: {
        id: {
          type: String,
          default: 'buy-addons-modal',
        },
        recipient_id: {
          type: Number|String,
          default: null,
        },
        organization: Object,
        title: {
          type: String,
          default: trans('buy_addons'),
        },
      },
      data() {
        return {
          trans: trans,
          loaded: false,
          items: [],
          selected: [],
          busy: false,

        }
      },
      computed: {
      },
      methods: {
        loadAddons() {
            this.loaded = false
            axios.get(`/org/${this.organization.id}/client/get_addons/${this.recipient_id}`)
            .then((response) => {
                this.loaded = true
                let items = response.data
                items = items.map((item) => {
                  item.addons.map((addon, index) => {
                    addon.index = index
                    addon.value = index
                    addon.text = `${addon.name} (${addon.price > 0 ? _.currency(addon.price) : this.trans('free')})`
                  })
                  return item
                });
                this.items = items
            })
            .catch((error) => {
                this.loaded = true
                this.$emit('error', error)
            })
        },
        onShown() {
          this.loadAddons()
          this.selected = []
        },
        onHidden() {
          this.$emit('hidden')
        },
        onBuy(e) {
            e.preventDefault()
            let selectedAddons = []

            selectedAddons = this.selected.map((item, index) => {
              const obj = { ...this.items[index] };
              obj.addons = item.map(i => obj.addons[i]);
              return obj;
            });

            if (selectedAddons.length > 0) {  
              this.onAddAddonToCart(selectedAddons, () => {
                window.location = `/org/${this.organization.id}/checkout`
              }) // then will not work with error
            }  
        },
        onAddAddonToCart(selectedAddons, callback) {
            this.busy = true
            this.error = null
            let url = `/org/${this.organization.id}/cart/add_class_addons`
            return axios.post(url, {
                addons: selectedAddons,
                recipient_id: this.recipient_id,
            })
            .then(response => {
                if (callback) {
                    callback()
                }
            })
            .catch(error => {
                this.busy = false
                this.error = _.errorFromAjax(error)
                _.toastError(this, this.error)
            })
      },
      },
      mounted() {
        window[_.camelCase(this.id)] = this
      },
    }
  </script>